// Traducciones al inglés: clave = texto en español exactamente como en el código.
// Servicios: tipos de servicio, planes, equipos, canciones, medios y reporte CCLI.
export default {
  // Términos comunes
  'Servicio': 'Service',
  'Ensayo': 'Rehearsal',
  'Canción': 'Song',
  'Encabezado': 'Header',
  'Medio': 'Media',
  'Elemento': 'Item',
  'Sin respuesta': 'Unconfirmed',
  'Declinó': 'Declined',
  'Declinaron': 'Declined',
  'Título': 'Title',
  'Título (opcional)': 'Title (optional)',
  'Serie': 'Series',
  'Horarios': 'Times',
  'Posición': 'Position',
  'Posiciones': 'Positions',
  'Equipo': 'Team',
  'Arreglo': 'Arrangement',
  'Tonalidad': 'Key',
  'Partitura': 'Chord chart',
  'Duración': 'Length',
  'Categoría': 'Category',
  'Nombre (opcional)': 'Name (optional)',
  'Fin (opcional)': 'End (optional)',
  'Programar': 'Schedule',
  'Autoprogramar': 'Auto-schedule',
  'Deshacer': 'Undo',
  'Original': 'Original',
  'Original ({key})': 'Original ({key})',
  '{n} bpm': '{n} bpm',
  'Duración inválida (min:seg)': 'Invalid length (min:sec)',

  // Navegación y tipos de servicio
  'Tipos de servicio': 'Service types',
  'Tipo de servicio': 'Service type',
  'Canciones': 'Songs',
  'Medios': 'Media',
  'Reporte CCLI': 'CCLI report',
  'Planes de servicio, equipos y programación de voluntarios por campus.': 'Service plans, teams and volunteer scheduling by campus.',
  '+ Tipo de servicio': '+ Service type',
  'Sin tipos de servicio': 'No service types',
  'Crea uno para empezar (p. ej. “Domingo 9:00 am”).': 'Create one to get started (e.g. “Sunday 9:00 am”).',
  'Toda la organización': 'Entire organization',
  'Nuevo tipo de servicio': 'New service type',
  'Domingo 9:00 am': 'Sunday 9:00 am',
  'Configurar@@tipo de servicio': 'Settings',
  'Se archivará el tipo de servicio. Sus planes se conservan.': 'The service type will be archived. Its plans will be kept.',
  'Planes': 'Plans',
  'Equipos ({n})': 'Teams ({n})',
  'Matriz': 'Matrix',

  // Lista de planes
  'Próximos': 'Upcoming',
  'Anteriores (6 meses)': 'Past (6 months)',
  '+ Nuevo plan': '+ New plan',
  'Sin planes en este periodo': 'No plans in this period',
  'Elige la fecha del plan': 'Choose the plan date',
  'Nuevo plan': 'New plan',
  'Crear plan': 'Create plan',
  'Horarios (hora local del campus)': 'Times (campus local time)',
  'a@@rango de horas': 'to',
  '+ Horario': '+ Time',

  // Equipos
  'Nuevo equipo': 'New team',
  'Nombre del equipo (p. ej. Alabanza)': 'Team name (e.g. Worship)',
  'Se programa por plan completo': 'Scheduled for the whole plan',
  'Se programa por horario': 'Scheduled by time',
  'Sin equipos': 'No teams',
  'por horario': 'by time',
  'por plan': 'by plan',
  '¿Archivar el equipo {name}?': 'Archive the {name} team?',
  'Líderes': 'Leaders',
  'Quitar líder': 'Remove leader',
  'Sin líderes. Los líderes pueden programar a su equipo.': 'No leaders. Leaders can schedule their own team.',
  'Agregar líder…': 'Add leader…',
  '¿Eliminar la posición {name}?': 'Delete the {name} position?',
  'Nueva posición (p. ej. Guitarra)': 'New position (e.g. Guitar)',
  'Personas que pueden servir en esta posición. La autoprogramación elige de esta lista.': 'People who can serve in this position. Auto-scheduling picks from this roster.',
  'Nadie todavía.': 'No one yet.',
  'Agregar persona…': 'Add person…',

  // Matriz
  'Sin planes en el rango': 'No plans in this range',

  // Plan
  'Serie: {title}': 'Series: {title}',
  'Duración {length}': 'Length {length}',
  'Orden del servicio ({n})': 'Order of service ({n})',
  'Personas ({n})': 'People ({n})',
  'Horarios ({n})': 'Times ({n})',
  'Copiar a otras fechas': 'Copy to other dates',
  'Editar plan': 'Edit plan',
  'Se eliminará el plan con su orden y personas programadas.': 'This will delete the plan along with its order of service and scheduled people.',
  'Eliminar plan': 'Delete plan',
  'Notas públicas': 'Public notes',
  'Copiar plan': 'Copy plan',
  'Se creó {n} plan': '{n} plan created',
  'Se crearon {n} planes': '{n} plans created',
  'Copiar': 'Copy',
  'Los horarios conservan la hora local del campus (incluso con cambio de horario de verano).': 'Times keep the campus local time (even across daylight saving time changes).',
  '+ Fecha': '+ Date',
  'Copiar orden del servicio': 'Copy order of service',
  'Copiar posiciones por cubrir': 'Copy needed positions',
  'Copiar personas (quedan sin respuesta)': 'Copy people (as unconfirmed)',

  // Orden del servicio
  '+ Agregar ítem': '+ Add item',
  'El plan no tiene ítems': 'This plan has no items',
  'Agrega canciones, encabezados y elementos del servicio.': 'Add songs, headers and service items.',
  'Solo algunos horarios': 'Only some times',
  'Instrucciones': 'Instructions',
  'Audio': 'Audio',
  'Video': 'Video',
  'Luces': 'Lights',
  'Escenario': 'Stage',
  'Duración inválida: usa minutos:segundos, p. ej. 4:30': 'Invalid length: use minutes:seconds, e.g. 4:30',
  'Elige una canción': 'Choose a song',
  'Agregar ítem': 'Add item',
  '¿Quitar este ítem del plan?': 'Remove this item from the plan?',
  'Duración (min:seg)': 'Length (min:sec)',
  'Cambiar canción': 'Change song',
  'Se presenta en': 'Included in',
  'Buscar por título, autor o número CCLI': 'Search by title, author or CCLI number',
  'Última vez {date}': 'Last used {date}',
  'Nunca usada': 'Never used',
  'Sin resultados. Agrégala en la biblioteca de canciones.': 'No results. Add it to the song library.',
  'Transpuesta': 'Transposed',
  'Imprimir': 'Print',
  'Este arreglo no tiene partitura': 'This arrangement has no chord chart',

  // Personas programadas
  '{n} confirmados': '{n} confirmed',
  '{n} sin respuesta': '{n} unconfirmed',
  '{n} declinaron': '{n} declined',
  'Solicitudes enviadas a {n} persona': 'Requests sent to {n} person',
  'Solicitudes enviadas a {n} personas': 'Requests sent to {n} people',
  '({n} sin correo ni teléfono: verán el aviso en el portal)': '({n} with no email or phone: they’ll see the request in the portal)',
  'Enviar solicitudes ({n})': 'Send requests ({n})',
  'Autoprogramación: {result}.': 'Auto-schedule: {result}.',
  'no había personas disponibles en las plantillas': 'no one was available in the rosters',
  'Autoprogramación deshecha': 'Auto-schedule undone',
  'Este tipo de servicio no tiene equipos': 'This service type has no teams',
  'Créalos en la pestaña Equipos del tipo de servicio.': 'Create them in the service type’s Teams tab.',
  '+ Programar': '+ Schedule',
  'Sin posición': 'No position',
  'notificado': 'notified',
  'Registrar respuesta': 'Record response',
  'Nadie programado.': 'No one scheduled.',
  'Cualquier posición': 'Any position',
  'Se necesitan {n} · {name}': '{n} needed · {name}',
  'Faltan {n}': '{n} missing',
  'Cubierto': 'Filled',
  '+ Posición por cubrir': '+ Needed position',
  'Programar en {team}': 'Schedule in {team}',
  'Programar de todos modos': 'Schedule anyway',
  'De la plantilla de la posición': 'From the position roster',
  'O busca a cualquier persona': 'Or search for anyone',
  'Tiene conflictos:': 'Has conflicts:',
  'Llena las posiciones por cubrir con personas de la plantilla de cada posición: primero quien hace más tiempo no sirve, evitando bloqueos y personas ya programadas a la misma hora. Puedes deshacerlo.': 'Fills needed positions with people from each position’s roster: those who haven’t served in the longest go first, skipping blockouts and people already scheduled at the same time. You can undo it.',
  '{n} por cubrir': '{n} needed',
  'sin posiciones por cubrir': 'no needed positions',
  'Respuesta de {name}': 'Response from {name}',
  'Estado actual: {status}. Úsalo cuando la persona responde en persona o por teléfono.': 'Current status: {status}. Use this when the person responds in person or by phone.',
  'Respuesta': 'Response',
  'Acepta': 'Accepts',
  'Declina': 'Declines',
  'Horarios que NO puede': 'Times they CAN’T make',
  'Motivo (opcional)': 'Reason (optional)',

  // Horarios y notas del plan
  '¿Eliminar este horario?': 'Delete this time?',
  'Horas en la zona del campus ({tz}).': 'Times in the campus time zone ({tz}).',
  'Editar horario': 'Edit time',
  'Nuevo horario': 'New time',
  'Notas del plan': 'Plan notes',
  'Eliminar nota': 'Delete note',
  'Sin notas.': 'No notes.',
  'Nota para todo el equipo': 'Note for the whole team',

  // Canciones
  'Biblioteca compartida por todos los campus.': 'Library shared by all campuses.',
  '+ Nueva canción': '+ New song',
  'Título, autor o número CCLI': 'Title, author or CCLI number',
  'Sin canciones': 'No songs',
  'Autor': 'Author',
  'Última vez': 'Last used',
  '{n} arreglo': '{n} arrangement',
  '{n} arreglos': '{n} arrangements',
  'Nunca': 'Never',
  'Nueva canción': 'New song',
  'Autor(es)': 'Author(s)',
  'Número CCLI': 'CCLI number',
  'Temas': 'Themes',
  'gracia, adoración': 'grace, worship',
  'Copyright': 'Copyright',
  'La canción se archivará (los planes anteriores la conservan).': 'The song will be archived (past plans keep it).',
  '+ Arreglo': '+ Arrangement',
  'Información': 'Information',
  'Copyright:': 'Copyright:',
  'Temas:': 'Themes:',
  'Sin información adicional.': 'No additional information.',
  'Historial de uso': 'Usage history',
  'Aún no se ha usado': 'Not used yet',
  'Editar arreglo': 'Edit arrangement',
  'Escrita en {key}': 'Written in {key}',
  'Tonalidades': 'Keys',
  'Eliminar tonalidad': 'Delete key',
  'Agrega las tonalidades que usan tus líderes (p. ej. “Voz de Ana – A”).': 'Add the keys your leaders use (e.g. “Ana’s voice – A”).',
  'Nombre (p. ej. Ana)': 'Name (e.g. Ana)',
  'Tonalidad inicial': 'Starting key',
  'Tonalidad final': 'Ending key',
  'Termina igual': 'Same ending',
  'Transponer a': 'Transpose to',
  'Sin partitura ni letra': 'No chord chart or lyrics',
  'Edita el arreglo y escribe o pega la partitura.': 'Edit the arrangement and type or paste the chord chart.',
  'Editar canción': 'Edit song',
  'BPM debe ser un número entero': 'BPM must be a whole number',
  'Nuevo arreglo': 'New arrangement',
  '¿Eliminar este arreglo?': 'Delete this arrangement?',
  'Compás': 'Meter',
  'Tonalidad en que está escrita la partitura': 'Key the chord chart is written in',
  'Vista previa': 'Preview',
  'Letra (si no hay partitura)': 'Lyrics (if there’s no chord chart)',
  'Notas del arreglo': 'Arrangement notes',

  // Medios
  'Imagen': 'Image',
  'Fondo@@medio': 'Background',
  'Cuenta regresiva': 'Countdown',
  'Documento': 'Document',
  'Videos, fondos y cuentas regresivas para usar en los planes.': 'Videos, backgrounds and countdowns to use in plans.',
  'Nuevo medio': 'New media',
  'Enlace (opcional)': 'Link (optional)',
  'Sin medios': 'No media',
  '¿Eliminar {name}?': 'Delete {name}?',

  // Editor de partituras
  'Elige la tonalidad para poder guardar la partitura': 'Choose the key to save the chord chart',
  'Escribe o pega los acordes en la línea de arriba de la letra, cada uno sobre su sílaba. También puedes ponerlos entre corchetes: [G]Sublime.': 'Type or paste the chords on the line above the lyrics, each one over its syllable. You can also put them in brackets: [G]Amazing.',
  'Aquí verás cómo queda la partitura.': 'Your chord chart preview appears here.',

  // Lista de canciones
  'Acordes': 'Chords',
  'Creada': 'Created',
  'Filtros': 'Filters',
  'Filtros ({n})': 'Filters ({n})',
  'Columnas': 'Columns',
  'Exportar CSV': 'Export CSV',
  'Exportando…': 'Exporting…',
  'Vista compacta': 'Compact view',
  'Música': 'Music',
  'Mayor o menor': 'Major or minor',
  'Mayor': 'Major',
  'Menor': 'Minor',
  'Nombre de la tonalidad': 'Key name',
  'Hombre, Mujer…': 'Male, Female…',
  'BPM desde': 'BPM from',
  'BPM hasta': 'BPM to',
  'Contenido': 'Content',
  'Letra': 'Lyrics',
  'Nombre del arreglo': 'Arrangement name',
  'Historial': 'History',
  'Todos': 'All',
  'Última vez desde': 'Last used from',
  'Última vez hasta': 'Last used to',
  'Creada desde': 'Created from',
  'Creada hasta': 'Created to',
  'Ver solo archivadas': 'Show archived only',
  'Quitar filtros': 'Clear filters',
  'Prueba con menos filtros.': 'Try fewer filters.',
  '{n} canción': '{n} song',
  '{n} canciones': '{n} songs',

  // Reporte de canciones
  'Reportes': 'Reports',
  'Canciones por semana': 'Songs by week',
  'Rango de fechas inválido': 'Invalid date range',
  'Reporte de canciones': 'Song report',
  'Qué se cantó en cada plan de un tipo de servicio.': 'What was sung in each plan of a service type.',
  'Canciones distintas': 'Different songs',
  'Canciones nuevas': 'New songs',
  'Primera vez en este tipo de servicio': 'First time in this service type',
  'Promedio por servicio': 'Average per service',
  'Nueva': 'New',
  'Ningún plan de este tipo de servicio tiene canciones en esas fechas.': 'No plans of this service type have songs in those dates.',
  'Crea un tipo de servicio para ver este reporte.': 'Create a service type to see this report.',
  'Abrir plan del {date}': 'Open plan for {date}',
  'Usada en este plan': 'Used in this plan',

  // Reporte CCLI
  'Usos': 'Uses',
  'Canciones usadas en planes del periodo, para reportar a CCLI.': 'Songs used in plans during the period, for reporting to CCLI.',
  'Descargar CSV': 'Download CSV',
  'Sin canciones en el periodo': 'No songs in this period',
  'Falta': 'Missing',
  'Periodo: {from} – {to}.': 'Period: {from} – {to}.',
  'Predeterminado@@arreglo': 'Default',
  "Plantilla": "Template",
  "Esta plantilla guarda el orden del servicio, los horarios y las posiciones por cubrir. Para usarla: en el tipo de servicio, «+ Nuevo plan» → «Desde una plantilla».": "This template keeps the order of service, the times and the positions to fill. To use it: in the service type, “+ New plan” → “From a template”.",
  "Archivos": "Files",
  "Guardar como plantilla": "Save as template",
  "Editar plantilla": "Edit template",
  "Se eliminará la plantilla. Los planes creados con ella no cambian.": "The template will be deleted. Plans created from it don’t change.",
  "Eliminar plantilla": "Delete template",
  "Nombre de la plantilla": "Template name",
  "Plantilla guardada": "Template saved",
  "Se guardan el orden del servicio, los horarios y una posición por cubrir por cada persona programada (sin sus nombres). Después podrás crear planes nuevos desde ella.": "The order of service, times and one position to fill for each scheduled person (without their names) are saved. Then you can create new plans from it.",
  "Domingo normal": "Regular Sunday",
  "Volver al plan": "Back to the plan",
  "Imprimir orden del servicio": "Print order of service",
  "Notas de cada ítem": "Notes on each item",
  "Equipo programado": "Scheduled team",
  "Hora": "Time",
  "Orden del servicio": "Order of service",
  "Tono {key}": "Key {key}",
  "+ Carpeta": "+ Folder",
  "Se borrará la carpeta «{name}». Sus tipos de servicio no se borran: quedan fuera de la carpeta.": "The folder “{name}” will be deleted. Its service types aren’t deleted: they just leave the folder.",
  "Vacía. Asigna tipos de servicio desde su configuración.": "Empty. Assign service types from their settings.",
  "Carpeta": "Folder",
  "Nueva carpeta": "New folder",
  "Reuniones de domingo": "Sunday gatherings",
  "Series ({n})": "Series ({n})",
  "Sin carpeta": "No folder",
  "Plantillas": "Templates",
  "Abre un plan y usa «Guardar como plantilla». Después podrás crear planes nuevos desde ella con «+ Nuevo plan».": "Open a plan and use “Save as template”. Then you can create new plans from it with “+ New plan”.",
  "{n} posición": "{n} position",
  "{n} posiciones": "{n} positions",
  "Empezar": "Start",
  "Plan en blanco": "Blank plan",
  "Desde una plantilla: {name}": "From a template: {name}",
  "Una serie agrupa planes de varias semanas (por ejemplo, una serie de mensajes). Se elige al crear o editar el plan.": "A series groups plans across several weeks (for example, a sermon series). Choose it when creating or editing the plan.",
  "+ Serie": "+ Series",
  "Sin series": "No series",
  "{n} plan": "{n} plan",
  "{n} planes": "{n} plans",
  "Se borrará la serie «{title}». Sus planes se conservan, sin serie.": "The series “{title}” will be deleted. Its plans are kept, without a series.",
  "Editar serie": "Edit series",
  "Nueva serie": "New series",
  "Romanos: la gracia que transforma": "Romans: grace that transforms",
  "Equipos": "Teams",
  "Líder de": "Leader of",
  "Última vez programado": "Last scheduled",
  "Próxima vez programado": "Next scheduled",
  "Quienes sirven en los equipos: sus posiciones y cuándo les toca.": "Who serves on the teams: their positions and when they're up next.",
  "Todos mis equipos": "All my teams",
  "Nombre o correo": "Name or email",
  "Escribir correo": "Write email",
  "Nadie coincide con la búsqueda": "No one matches the search",
  "Todavía no hay personas en los equipos": "There are no people on the teams yet",
  "Agrega personas a las posiciones de cada equipo desde el tipo de servicio.": "Add people to each team's positions from the service type.",
  "Próxima vez": "Next time",
  "Último acceso": "Last sign-in",
  "El archivo supera el tamaño máximo de 100 MB": "The file exceeds the 100 MB maximum size",
  "Ver plan y ensayar": "View plan and rehearse",
  "Ensayar": "Rehearse",
  "Imagen de la serie": "Series image",
  "Imagen de la serie «{title}»": "Image for the series “{title}”",
  "Imagen del plan": "Plan image",
  "Agregar la imagen de la serie": "Add the series image",
  "Agregar imagen": "Add image",
  "¿Quitar la imagen de la serie? Se quita de todos sus planes.": "Remove the series image? It will be removed from all of its plans.",
  "¿Quitar la imagen de este plan?": "Remove this plan's image?",
  "Se usa en todos los planes de la serie «{title}».": "It's used on every plan in the series “{title}”.",
  "Transpuesta a {key} (tonalidad de este plan).": "Transposed to {key} (this plan's key).",
  "Este plan todavía no tiene canciones": "This plan doesn't have songs yet",
  "Cuando agreguen canciones al orden del servicio, aquí estarán sus partituras y audios.": "When songs are added to the order of service, their charts and audio will be here.",
  "Tonalidad de {name}": "{name}'s key",
  "Ocultar partitura": "Hide chart",
  "Ver partitura": "View chart",
  "Para esta tonalidad ({key})": "For this key ({key})",
  "Sin archivos en esta tonalidad.": "No files for this key.",
  "De la canción": "From the song",
  "Sin archivos de la canción.": "No files for the song.",
  "Solo para este plan": "Just for this plan",
  "Nada más para este plan.": "Nothing else for this plan.",
  "Otros elementos": "Other items",
  "Sin archivos.": "No files.",
  "Archivos del plan": "Plan files",
  "Sin archivos generales.": "No general files.",
  "Quién sirve": "Who's serving",
  "El orden del servicio todavía no está listo": "The order of service isn't ready yet",
  "Sin archivos en esta tonalidad. Sube aquí la pista o la partitura en {key}.": "No files for this key. Upload the track or chart in {key} here.",
  "Archivos del arreglo": "Arrangement files",
  "Para todos: partituras, cifrados, secuencias, pistas o videos de referencia. Lo de una voz o tonalidad en particular va en «Tonalidades».": "For everyone: charts, chord sheets, sequences, tracks or reference videos. Anything for a particular voice or key goes under “Keys”.",
  "Enlace": "Link",
  "Presentación": "Presentation",
  "Texto o cifrado": "Text or chord sheet",
  "«{name}» pesa más de 100 MB. Súbelo comprimido o como enlace (Dropbox, Google Drive…).": "“{name}” is larger than 100 MB. Upload it compressed or as a link (Dropbox, Google Drive…).",
  "Sube partituras, pistas de audio, videos o presentaciones, o agrega enlaces.": "Upload charts, audio tracks, videos or presentations, or add links.",
  "Escuchar": "Listen",
  "Descargar {name}": "Download {name}",
  "+ Archivo": "+ File",
  "O arrastra los archivos aquí. Hasta 100 MB cada uno.": "Or drag the files here. Up to 100 MB each.",
  "Importar canciones (CSV)": "Import songs (CSV)",
  "Primero se revisa sin guardar nada.": "It is reviewed first without saving anything.",
  "Sirve la exportación de canciones de Planning Center tal como sale (Songs → Export CSV): trae cada arreglo con su BPM, duración, tonalidades (Hombre, Mujer…) y partitura. Las partituras con los acordes encima de la letra se convierten a ChordPro para poder transponerlas; las que no tienen acordes quedan como letra.":
    "A Planning Center song export works as is (Songs → Export CSV): it brings each arrangement with its BPM, length, keys (Male, Female…) and chord chart. Charts with chords above the lyrics are converted to ChordPro so they can be transposed; charts without chords are kept as lyrics.",
  "También sirve un CSV sencillo con una fila por canción: título, autor, CCLI, temas, tonalidad, BPM y letra. Volver a importar el mismo archivo actualiza las canciones en lugar de duplicarlas.":
    "A simple CSV with one row per song also works: title, author, CCLI, themes, key, BPM and lyrics. Importing the same file again updates the songs instead of duplicating them.",
  "{rows} canciones · {created} nuevas · {updated} existentes por actualizar · {arrangements} arreglos · {keys} tonalidades · {errors} con errores.":
    "{rows} songs · {created} new · {updated} existing to update · {arrangements} arrangements · {keys} keys · {errors} with errors.",
  "Importación completa: {created} canciones nuevas y {updated} actualizadas.": "Import complete: {created} new songs and {updated} updated.",
  "{chords} partituras con acordes (ChordPro) · {lyrics} solo con letra.": "{chords} chord charts (ChordPro) · {lyrics} lyrics only.",
  "Importar equipos (CSV)": "Import teams (CSV)",
  "Una fila por persona y posición: campus, tipo_de_servicio, equipo, posicion, id_persona (el número de la persona en el sistema anterior, el mismo de la importación de Personas), nombre, apellido y lider (si/no). Crea los tipos de servicio, equipos y posiciones que falten y agrega a cada persona a su posición. No borra nada: volver a importar el mismo archivo no duplica.":
    "One row per person and position: campus, tipo_de_servicio (service type), equipo (team), posicion (position), id_persona (the person's number in the previous system, the same one used by the People import), nombre, apellido and lider (si/no). It creates any missing service types, teams and positions and adds each person to their position. Nothing is deleted: importing the same file again does not duplicate.",
  "{types} tipos de servicio ({newTypes} nuevos) · {teams} equipos · {positions} posiciones · {assignments} asignaciones de {people} personas · {leaders} líderes · {errors} con errores.":
    "{types} service types ({newTypes} new) · {teams} teams · {positions} positions · {assignments} assignments of {people} people · {leaders} leaders · {errors} with errors.",
  "Importación completa: {teams} equipos con {assignments} asignaciones de personas.": "Import complete: {teams} teams with {assignments} person assignments.",
  "Sin respuesta (deshacer la respuesta registrada)": "No response (undo the recorded response)",
  "Abrir la canción": "Open the song",
  "Agregar a una persona del plan…": "Add a person from the plan…",
  "Agregar quién dirige": "Add who leads",
  "Agrégalos en Medios": "Add them in Media",
  "Antes": "Before",
  "Archivos ({n})": "Files ({n})",
  "Canción vinculada": "Linked song",
  "Categorías de notas": "Note categories",
  "Después": "After",
  "Dirige": "Leads",
  "Durante": "During",
  "Escribe un título": "Enter a title",
  "Este tipo de servicio todavía no tiene categorías de notas. Agrégalas en «Configurar».": "This service type doesn’t have note categories yet. Add them in “Settings”.",
  "Instrucciones o texto largo de este ítem": "Instructions or long text for this item",
  "La biblioteca no tiene medios": "The library has no media",
  "Momento": "When",
  "Quitar a {name}": "Remove {name}",
  "Secuencia": "Sequence",
  "Sin detalle.": "No details.",
  "Sin medios.": "No media.",
  "Una por línea. Aparecen en cada ítem del plan, por ejemplo Producción, Banda o Comunicadores.": "One per line. They appear on each plan item, for example Production, Band or Communicators.",
  "V1, V2, C×2, E": "V1, V2, C×2, E",
  "Vincular un medio de la biblioteca…": "Link media from the library…",
  "Vincular un medio": "Link media",
  "Ítem anterior": "Previous item",
  "Ítem siguiente": "Next item",
  "Ítem: {title}": "Item: {title}",
  "Con problemas": "With problems",
  "Deja esta página abierta hasta que termine.": "Keep this page open until it finishes.",
  "Detener": "Stop",
  "El manifiesto no tiene filas.": "The manifest has no rows.",
  "En id_cancion va el identificador del sistema anterior o el título exacto. Sin tonalidad, el archivo queda en el arreglo. Lo que ya existe con el mismo nombre se omite, así que puedes detenerte y retomar sin duplicar nada.": "In id_cancion, use the ID from the previous system or the exact title. Without a key, the file goes on the arrangement. Anything that already exists with the same name is skipped, so you can stop and resume without duplicating anything.",
  "Elige una carpeta con los archivos y un archivo manifiesto.csv que diga a dónde va cada uno. Sus columnas son: id_cancion, arreglo, tonalidad, tipo (archivo, enlace o secuencia), nombre, ruta, url y texto.": "Choose a folder with the files and a manifiesto.csv file saying where each one goes. Its columns are: id_cancion, arreglo, tonalidad, tipo (archivo, enlace or secuencia), nombre, ruta, url and texto.",
  "Importar archivos de canciones": "Import song files",
  "Importar archivos": "Import files",
  "Importar {n} elemento": "Import {n} item",
  "Importar {n} elementos": "Import {n} items",
  "La carpeta no tiene el archivo {name}.": "The folder doesn’t have the file {name}.",
  "No está en la carpeta": "Not in the folder",
  "Pesa más de 100 MB": "Larger than 100 MB",
  "Progreso de la importación": "Import progress",
  "Revisando…": "Checking…",
  "{done} de {total}: {name}": "{done} of {total}: {name}",
  "Listos:": "Ready:",
  "Ya están:": "Already there:",
  "Con problemas:": "With problems:",
  "Importados: {imported}. Omitidos porque ya estaban: {skipped}. Fallaron: {failed}.": "Imported: {imported}. Skipped because already there: {skipped}. Failed: {failed}.",
} satisfies Record<string, string>;
